import apiWorker from '../apiWorker'

const contact_alerts = {
    find : (case_id) => apiWorker('get', `/v1/api/contacts_alerts/case/${case_id}`),
}

export default contact_alerts;